import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin } from "./useGoogleLogin";
import { useRef } from "react";

interface GoogleLoginButtonProps {
  onAuthSuccess?: (authToken: string) => void;
  returnScheme?: string;
}

export const GoogleLoginButton = ({ onAuthSuccess, returnScheme }: GoogleLoginButtonProps = {}) => {
  const { handleGoogleSuccess, error } = useGoogleLogin({ onAuthSuccess, returnScheme });
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div className="flex-1 basis-[calc(50%-0.25rem)]">
      <div className="relative">
        <div className="" ref={ref}>
          <GoogleLogin
            onSuccess={({ credential }) => {
              if (credential) {
                handleGoogleSuccess(credential);
              }
            }}
            onError={() => {}}
            width="400"
            size="large"
          />
        </div>
      </div>
      {error && <div className="mt-2 text-sm text-red-600 bg-red-50 p-3 rounded-md">{error}</div>}
    </div>
  );
};
